import { render, staticRenderFns } from "./NisScore.vue?vue&type=template&id=384c6517&scoped=true"
import script from "./NisScore.vue?vue&type=script&lang=js"
export * from "./NisScore.vue?vue&type=script&lang=js"
import style0 from "./NisScore.vue?vue&type=style&index=0&id=384c6517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c6517",
  null
  
)

export default component.exports